<template>
	<MessageBubble :message="message" />
</template>
<script setup lang="ts">
import { Message } from "@/type/api";
import MessageBubble from "@/components/MessageBubble.vue";
interface Props {
	message: Message;
}
const props = defineProps<Props>();
</script>
